module.exports = __webpack_public_path__ + "img/protective_gear3.13d02cb0.png";